'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidArchive = function IoAndroidArchive(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.2 7.8c0.6 0.6 0.8 1.3 0.8 2.3v22.6c0 1.9-1.6 3.6-3.6 3.6h-25.3c-2 0-3.6-1.7-3.6-3.6v-22.6c0-1 0.2-1.7 0.8-2.3l2.6-3c0.4-0.7 1.2-1 2-1h21.7c0.8 0 1.6 0.3 2 1z m-15.4 22.1l9.9-9.9h-6.4v-3.6h-7.1v3.6h-6.4z m-12.5-22.6h24.8l-1.7-1.8h-21.7z' })
        )
    );
};

exports.default = IoAndroidArchive;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-archive.js
// module id = 1835
// module chunks = 0